import { useEffect, useRef } from 'react';

export const KINSHIP_STRIKE_ANIMATION_VARIANT = 'kinship_strike_black_stick';

/**
 * Mission 74 KINSHIP: black damage beam from opponent general portrait to the viewer's general.
 */
export function useExploreUnknownKinshipGeneralDamageAnimations(gameState, viewerUserId, registerAnimation) {
  const prevLogLengthRef = useRef(0);

  useEffect(() => {
    if (!gameState?.actionLog || viewerUserId == null || !registerAnimation) {
      prevLogLengthRef.current = gameState?.actionLog?.length ?? 0;
      return;
    }
    if (Number(gameState.exploreUnknownMissionIndex) !== 74) {
      prevLogLengthRef.current = gameState.actionLog.length;
      return;
    }

    const prevLen = prevLogLengthRef.current;
    const log = gameState.actionLog;
    if (!Array.isArray(log) || log.length <= prevLen) {
      prevLogLengthRef.current = log.length;
      return;
    }

    const humanId = String(viewerUserId);
    for (let i = prevLen; i < log.length; i += 1) {
      const entry = log[i];
      if (!entry || entry.type !== 'eu-kinship-general-damage') continue;
      if (String(entry.targetPlayerId) !== humanId) continue;

      registerAnimation({
        fromSlot: {
          zone: 'general',
          index: null,
          playerId: 'opponent',
        },
        toSlot: {
          zone: 'general',
          index: null,
          playerId: 'your',
        },
        animationType: 'opponent',
        deployAnimationVariant: KINSHIP_STRIKE_ANIMATION_VARIANT,
        animationKey: `kinship-general-${entry.sequence ?? i}-${Date.now()}`,
      });
    }

    prevLogLengthRef.current = log.length;
  }, [gameState, viewerUserId, registerAnimation]);
}
